import MaskedInput from 'vue-text-mask';
// App main
const event = async () => {
    // Async load the vue module
    const { default: Vue } = await import(/* webpackChunkName: "vue" */ 'vue');
    const { default: axios } = await import(/* webpackChunkName: "axios" */ 'axios');
    // Create our vue instance
    const vm = new Vue({
        delimiters: ['${', '}'],
        el: "#eventRegisterForm",
        components: {
            MaskedInput
        },
        data() {
            return {
                fullName: '',
                email: '',
                phone: '+7',
                company: '',
                city: '',
                position: '',
                numberOfParticipants: '',
                sending: false,
                isModalVisible: false,
                modalTitle: '',
                modalBody: '',
            }
        },
        methods: {
            submitForm() {
                if (this.sending) {
                    return;
                }
                if (this.fullName.length < 3) {
                    window.alert('Пожалуйста, заполните ФИО');
                    return;
                }
                if (this.email.length < 3) {
                    window.alert('Пожалуйста, заполните email');
                    return;
                }
                if (this.position.length < 2) {
                    window.alert('Пожалуйста, заполните должность');
                    return;
                }
                // if (this.email.length > 3) {
                //     var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                //     if (!re.test(this.email.toLowerCase())) {
                //         window.alert('Пожалуйста, введите верный email');
                //         return;
                //     }
                // }
                // if (this.phone.length < 16 || this.phone.indexOf('_') > -1) {
                //     window.alert('Пожалуйста, введите телефон');
                //     return;
                // }
                // if (this.city.length < 3) {
                //     window.alert('Пожалуйста, введите город');
                //     return;
                // }
                var data = {
                    title: `${this.fullName} - ${this.position} ${this.company}`,
                    slug: `${window.Craft.eventID}`,
                    'fields[event][]': window.Craft.eventID,
                    action: 'guest-entries/save',
                    'fields[fullName]': this.fullName,
                    'fields[email]': this.email,
                    'fields[phone]': this.phone,
                    'fields[company]': this.company,
                    'fields[city]': this.city,
                    'fields[position]': this.position,
                    'fields[numberOfParticipants]': this.numberOfParticipants,
                    o9HCrd6F8f7epecw: '',
                    sectionUid: 'fcbc093d-1031-4305-907a-6371bcb52055',
                }
                data[window.Craft.csrfTokenName] = window.Craft.csrfTokenValue;
                var formData = new FormData();

                for (var key in data) {
                    formData.append(key, data[key]);
                }
                this.sending = true
                axios.post('/', formData).then(response => {
                    if (response.data.success) {
                        this.modalTitle = 'Ваша заявка на участие принята!';
                        this.modalBody = 'Мы свяжемся с вами в ближайшее время';
                        this.isModalVisible = true;
                        setTimeout(() => this.isModalVisible = false, 3000);

                        this.fullName = '';
                        this.email = '';
                        this.phone = '';
                        this.company = '';
                        this.position = '';
                        this.city = '';
                        this.numberOfParticipants = '';
                    } else {
                        this.modalTitle = 'Ошибка';
                        this.modalBody = 'К сожалению у нас на сайте произошла ошибка. Мы постораемся исправить ее как можно скорее, а пока вы можете <a href="/contacts">связаться с нами по телефону</a>.';
                        this.isModalVisible = true;
                        setTimeout(() => this.isModalVisible = false, 10000);
                    }
                    this.sending = false;
                }, () => { this.sending = false })
            }
        }
    });

    return vm;
};

event().then((vm) => {
    console.log('Events')
});